import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';
// import getCurrentUser from '../auth/index'

export default async function GetAllActivities(){
    
    try {
      const response = await axios.get(`${BASE}/activities`)
      const {data} = response
      
      return data
      
      
    } catch (error) {
      console.error(error);
    } 
}